import React from 'react';
import ArticleLink from '../models/ArticleLink';
import ArticleAuthorLink from './ArticleAuthorLink';
import PrimaryTaxonomyItemLink from './PrimaryTaxonomyItemLink';
// TODO: use lineClamp helper instead of ClampLines
import ClampLines from 'react-clamp-lines';
import Link from '@/components/Link';
import ImageUtils from '@gik/core/utils/ImageUtils';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';

export const blogEndpoint = 'articles';

export enum ArticleLinkCardStyle {
  carousel = 'carousel',
  featured = 'featured', // 2-column on desktop, 1 column mobile
  featuredHalf = 'featured-half', // half-size, 1 column on desktop, full size on mobile
  small = 'small', // single column on desktop, 2-column on mobile
  smallHorizontal = 'small-horizontal', // 2-column on both
}

interface ArticleLinkCardProps {
  articleLink: ArticleLink;
  cardStyle: ArticleLinkCardStyle;
  maxLines?: number;
  hidePrimaryTaxonomy?: boolean;
  headingLevel?: number;
}

export default function ArticleLinkCard({
  articleLink,
  cardStyle,
  maxLines,
  hidePrimaryTaxonomy,
  headingLevel = 3,
}: ArticleLinkCardProps) {
  const isMdDown = useBreakpoint(Breakpoint.MD_DOWN);

  const twoColumnDesktopCards = [ArticleLinkCardStyle.smallHorizontal];
  const twoColumnMobileCards = [ArticleLinkCardStyle.small, ArticleLinkCardStyle.smallHorizontal];
  const isTwoColumnCard =
    (isMdDown && twoColumnMobileCards.indexOf(cardStyle) > -1) ||
    (!isMdDown && twoColumnDesktopCards.indexOf(cardStyle) > -1);

  const articleLinkUrl = `/${blogEndpoint}/${articleLink.articleSlug}`;
  const _maxLines = maxLines || (isTwoColumnCard ? 2 : 3);

  // todo turn into article, link rich text info, author page etc

  return (
    <article className={`article-link-card ${cardStyle.toString()}`}>
      <Link href={articleLinkUrl}>
        <a className="column-1">
          <aside
            className="image"
            style={{
              backgroundImage: ImageUtils.imageOrNotFoundGradient(
                [
                  ArticleLinkCardStyle.featured,
                  ArticleLinkCardStyle.featuredHalf,
                  ArticleLinkCardStyle.carousel,
                ].indexOf(cardStyle) >= 0
                  ? articleLink.largeImageUrl
                  : articleLink.smallImageUrl
              ),
            }}
          />
        </a>
      </Link>
      <main className="column-2">
        <div className="content">
          <PrimaryTaxonomyItemLink articleLink={articleLink} hidden={hidePrimaryTaxonomy} />
          <Link href={articleLinkUrl}>
            <a>
              <ClampLines
                text={articleLink.title}
                id={articleLink.articleSlug}
                lines={_maxLines}
                ellipsis="..."
                buttons={false}
                className={'title' + (articleLink.isPreviewOnly ? ' preview' : '') + ` max-lines-${_maxLines}`}
                innerElement={`h${headingLevel}`}
              />
            </a>
          </Link>
          <ArticleAuthorLink articleLink={articleLink} />
        </div>
      </main>
    </article>
  );
}
